// extracted by mini-css-extract-plugin
export default {"container":"MicrositePage_container__iqX9m","content":"MicrositePage_content__+AL5I","title":"MicrositePage_title__1FJC3","subtitle":"MicrositePage_subtitle__1CnZ9"};